const escapeRegex = (value) => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export const createCookieStorage = (config = {}) => {
    const { days = 7, path = '/', domain, secure = window.location.protocol === 'https:', sameSite = 'Lax', namespace = '', } = config;
    const withNamespace = (key) => namespace ? `${namespace}:${key}` : key;
    return {
        getItem(key) {
            const fullKey = withNamespace(key);
            const pattern = new RegExp(`(?:^|; )${escapeRegex(fullKey)}=([^;]*)`);
            const match = document.cookie.match(pattern);
            return match ? decodeURIComponent(match[1]) : null;
        },
        setItem(key, value, options = {}) {
            var _a, _b, _c, _d, _e;
            const fullKey = withNamespace(key);
            const finalDays = (_a = options.days) !== null && _a !== void 0 ? _a : days;
            const finalPath = (_b = options.path) !== null && _b !== void 0 ? _b : path;
            const finalDomain = (_c = options.domain) !== null && _c !== void 0 ? _c : domain;
            const finalSecure = (_d = options.secure) !== null && _d !== void 0 ? _d : secure;
            const finalSameSite = (_e = options.sameSite) !== null && _e !== void 0 ? _e : sameSite;
            let cookie = `${fullKey}=${encodeURIComponent(value)}`;
            if (typeof finalDays === 'number') {
                const expires = new Date(Date.now() + finalDays * 864e5);
                cookie += `; Expires=${expires.toUTCString()}`;
            }
            if (finalPath)
                cookie += `; Path=${finalPath}`;
            if (finalDomain)
                cookie += `; Domain=${finalDomain}`;
            if (finalSecure)
                cookie += `; Secure`;
            if (finalSameSite)
                cookie += `; SameSite=${finalSameSite}`;
            document.cookie = cookie;
        },
        removeItem(key, options = {}) {
            this.setItem(key, '', Object.assign(Object.assign({}, options), { days: -1 }));
        },
        clear() {
            if (!namespace) {
                throw new Error('clear() is only supported when a namespace is configured.');
            }
            const prefix = `${namespace}:`;
            const cookies = document.cookie ? document.cookie.split('; ') : [];
            for (const cookie of cookies) {
                const eqIndex = cookie.indexOf('=');
                const rawKey = eqIndex >= 0 ? cookie.slice(0, eqIndex) : cookie;
                if (rawKey.startsWith(prefix)) {
                    this.removeItem(rawKey.slice(prefix.length));
                }
            }
        },
    };
};
